import popoverStyle from '@salesforce/retail-react-app/app/theme/components/base/popover'

export default {
    ...popoverStyle,
    baseStyle: {
        ...popoverStyle.baseStyle,
        popper: {
            ...popoverStyle.baseStyle.popper,
            boxShadow: 'unset',
            zIndex: 'popover',
        },
    },
}
